exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card.card-reserva {\n    box-shadow: 0px 0px 25px 1px rgb(12 59 90 / 30%);\n}\n", ""]);

// exports
